import React from 'react';
import { useQuery } from 'react-query';
import { Popover, List, Skeleton, Card } from 'antd';
import ModalController from 'components/ModalController';
import {
  GetListProcTaskCheck,
  UpdateProcTaskCheckStatus,
  ViewProcTaskCheckResponse,
} from 'services/workflow';
import AntButton from '../../../components/Button';
import CheckModal from '../../workflow/CheckModal';

import RouterLink from '../../../components/RouterLink';
import PopoverController from '../../../components/PopoverController';

const getUrl = (procmodule: string, id: number) => {
  if (procmodule === 'SINVOICE') {
    return `/supplier-invoice/${id}`;
  } else if (procmodule === 'PROPOSAL') {
    return `/proposal/${id}`;
  } else if (procmodule === 'CINVOICE') {
    return `/clientinvoice/${id}`;
  } else if (procmodule === 'THIRDPARTY') {
    return `/third-party/${id}`;
  }
  return undefined;
};

export type ChecksTableProps = {
  title?: string;
  height?: number;
  isFromLink?: boolean;
  checkTable?: ViewProcTaskCheckResponse[];
};

const ChecksTable = (props: ChecksTableProps) => {
  const { title, height, isFromLink, checkTable } = props;

  const { data, refetch, isFetching } = useQuery(
    'GetListProcTaskCheck',
    () => GetListProcTaskCheck().then((res) => res.list || []),
    {
      enabled: !isFromLink,
    }
  );

  const dataTable = checkTable ?? data;

  const actionCheck = (proctaskcheckid: number, checkstatus: string) => {
    return UpdateProcTaskCheckStatus({
      proctaskcheckid,
      checkstatus,
      authid: 0,
      cteid: 0,
      acceptedvalue: 0,
      comment: '',
    }).then(() => {
      refetch();
    });
  };

  return (
    <Card title={title} size="small" type="inner" style={{ height: height }}>
      <List
        bordered
        pagination={{
          pageSize: 3,

          size: 'small',
        }}
        dataSource={dataTable ?? []}
        itemLayout="horizontal"
        renderItem={(item) => (
          <List.Item
            key={item.proctaskcheckid}
            actions={[
              <PopoverController key={item.proctaskcheckid}>
                {({ setVisible, visible }) => (
                  <Popover
                    placement="bottomRight"
                    visible={visible}
                    trigger="click"
                    onVisibleChange={setVisible}
                    content={
                      item.actioncheck === 'ACTION' ? (
                        <div>
                          <AntButton
                            comcode="refus"
                            onClick={(e) => {
                              actionCheck(item.proctaskcheckid, 'REFUS');
                              setVisible(false);
                            }}
                          />
                          <AntButton
                            comcode="accept"
                            onClick={(e) => {
                              actionCheck(item.proctaskcheckid, 'ACCEPT');
                              setVisible(false);
                            }}
                          />
                        </div>
                      ) : (
                        <AntButton
                          comcode="cancel"
                          onClick={(e) => {
                            actionCheck(item.proctaskcheckid, 'CANCEL');
                            setVisible(false);
                          }}
                        />
                      )
                    }
                  >
                    {/* <AntButton
                      comcode="action"
                      icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
                      size="small"
                      onClick={() => setVisible(true)}
                    /> */}
                  </Popover>
                )}
              </PopoverController>,
            ]}
          >
            <Skeleton avatar title={false} loading={isFetching} active>
              <List.Item.Meta
                title={
                  <RouterLink to={getUrl(item.procmodule, item.objectid)}>
                    {item.modulename} - {item.objectreference}
                  </RouterLink>
                }
                description={item.cmessage}
              />
              <div>
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>{item.cmessage}</a>

                      <CheckModal
                        entityId={item.objectid}
                        entity={item.procmodule}
                        taskid={item.taskid}
                        checkid={item.proctaskcheckid}
                        visible={visible}
                        title={item.modulename + ' - ' + item.objectreference}
                        onCancel={() => setVisible(false)}
                        onSuccess={() => setVisible(false)}
                      />
                    </>
                  )}
                </ModalController>
                <div style={{ color: 'blue' }}>
                  {' '}
                  {item.sendername +
                    ' -> ' +
                    item.receivertypelabel +
                    ' ' +
                    item.receiverroleprofilelabel}
                </div>
              </div>
            </Skeleton>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default ChecksTable;
